import { createContext, useContext, useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";

const SSOContext = createContext();
SSOContext.displayName = "SSOContext";

function SSOProvider({ children }) {
  const [SSOData, setSSOData] = useState(null);

  const clear = () => setSSOData({});

  const value = useMemo(() => [SSOData, setSSOData, clear], [SSOData]);

  useEffect(() => {
    const handleMessage = (event) => {
      // ✅ Optional: verify the sender's origin
      // if (event.origin !== "https://your-parent-domain.com") return;

      if (event.data?.message === "SSO_DATA") {
        setSSOData(event.data.payload); // store only payload, not whole event
      }
    };
    window.parent.postMessage({ message: "REQUEST_SSO" }, "*");

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return <SSOContext.Provider value={value}>{children}</SSOContext.Provider>;
}

function useSSOInfo() {
  return useContext(SSOContext) || [];
}

SSOProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { SSOProvider, useSSOInfo };
